import { motion } from "framer-motion";
import { GALLERY } from "../lib/site";

// 5 real JSE job photos in an asymmetric bento layout
const spans = [
  "md:col-span-7 md:row-span-2", // cabinets (large feature)
  "md:col-span-5",                // green accent
  "md:col-span-5",                // blue accent
  "md:col-span-7",                // black theater (wide)
  "md:col-span-12",               // bonus room (full width banner)
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      className="py-24 lg:py-32 border-t border-[#E5E5E0] bg-[#FFFFFF]"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <span className="font-sans-body text-[11px] uppercase tracking-[0.3em] text-[#CC5500]">
              (Gallery)
            </span>
            <h2 className="mt-4 font-serif-display text-4xl lg:text-6xl tracking-tightest text-[#1C1C1A] leading-[0.95]">
              Real jobs,
              <br />
              <em className="font-light">real homes.</em>
            </h2>
          </div>
          <p className="lg:max-w-sm font-sans-body text-base text-[#4A4A46] leading-relaxed">
            A handful of recent projects across the Fort Worth metro — cabinets,
            accent walls, full-room refreshes, and a blackout media room.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 auto-rows-[260px]">
          {GALLERY.map((it, i) => (
            <motion.figure
              key={it.key}
              initial={{ opacity: 0, scale: 0.97 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.08 * i }}
              className={`${spans[i]} relative overflow-hidden group cursor-pointer border border-[#E5E5E0] bg-[#F5F5F0]`}
              data-testid={`gallery-item-${it.key}`}
            >
              <img
                src={it.src}
                alt={it.caption}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1C1C1A]/70 via-[#1C1C1A]/0 to-[#1C1C1A]/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <figcaption className="absolute bottom-5 left-5 right-5 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                <span className="block font-sans-body text-[10px] uppercase tracking-[0.25em] text-[#CC5500] mb-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  JSE · Recent work
                </span>
                <span className="block font-serif-display text-xl text-[#F5F5F0] leading-tight opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  {it.label}
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
